import {FC, useEffect, useRef, useState} from 'react'
import {Step1} from './steps/Step1'
import {Step2} from './steps/Step2'
import {Formik, Form, FormikValues} from 'formik'
import {
  ICreateContractPayment,
  createLicenseSchemas,
  initialValues,
} from './CreateContractPaymentHelper'
import {KTSVG} from '../../../../../../../_metronic/helpers'
import {StepperComponent} from '../../../../../../../_metronic/assets/ts/components/_StepperComponent'
import {useIntl} from 'react-intl'
import {AnimaBaixo} from '../../../../../../../_metronic/assets/animation/styles'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL || 'api'

const Vertical: FC = () => {
  //BUSCA TOKEN NO LOCALSTORAGE
  let token = localStorage.getItem('auth_storage')
  if (token) token = token.replace(/['"]+/g, '')

  const navigate = useNavigate()
  const intl = useIntl()
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [currentSchema, setCurrentSchema] = useState(createLicenseSchemas[0])
  const [initValues] = useState<ICreateContractPayment>(initialValues)

  const [loading, setLoading] = useState(false)
  const [passos, setPassos] = useState(1)
  const totalpassos = 2

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const prevStep = () => {
    setPassos(passos - 1)
    if (!stepper.current) {
      return
    }

    stepper.current.goPrev()

    setCurrentSchema(createLicenseSchemas[stepper.current.currentStepIndex - 1])
  }

  //INICIO SUBMIT FORM
  const datasend = new FormData() //formdata object

  const submitStep = async (values: ICreateContractPayment, actions: FormikValues) => {
    if (!stepper.current) {
      return
    }
    setCurrentSchema(createLicenseSchemas[stepper.current.currentStepIndex])
    if (stepper.current.currentStepIndex !== totalpassos) {
      setPassos(passos + 1)
      stepper.current.goNext()
    } else {
      console.log('ADD LICENÇA VALORES', values)
      //TRATAMENTO DE DADOS - MOEDA

      if (values.amount_paid) values.amount_paid = values.amount_paid.replaceAll('.', '')
      datasend.append('amount_paid', values.amount_paid?.toString() || '')

      //INSERINDO DADOS NO FORMDATA
      datasend.append('observations', values.observations || '')
      datasend.append('contract_uuid', values.contract_uuid || '')
      datasend.append(' owner_id', values.owner_id?.toString() || '')
      datasend.append('reference_date', values.reference_date || '')
      datasend.append('payday', values.payday || '')
      datasend.append('paid', values.paid?.toString() || '')

      console.log('ARQUIVO', values.proof_payment)
      if (values.proof_payment) {
        datasend.set('proof_payment', values.proof_payment as File)
      }

      try {
        setLoading(true)

        await axios({
          method: 'post',
          url: `${API_URL}/sgt/v1/contracts/${values.contract_uuid}/payments`,
          data: datasend,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })

        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'LICENSES.SWAL_ADD'}),
          showConfirmButton: false,
          timer: 2000,
        })
        setLoading(false)
        actions.resetForm()
        navigate(`/contracts${values.contract_uuid}`)
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'LICENSES.SWAL_ADD_ERROR'}),
          showConfirmButton: false,
          timer: 1500,
        })
        setLoading(false)
      }
      // actions.resetForm()
    }
  }

  useEffect(() => {
    if (!stepperRef.current) {
      return
    }

    loadStepper()
  }, [stepperRef])

  return (
    <div
      ref={stepperRef}
      className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid'
      id='kt_create_account_stepper'
    >
      <AnimaBaixo>
        <div className='card d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px w-xxl-400px me-9'>
          <div className='card-body px-6 px-lg-10 px-xxl-15 py-10'>
            <div className='stepper-nav'>
              <div className='stepper-item current' data-kt-stepper-element='nav'>
                <div className='stepper-wrapper'>
                  <div className='stepper-icon w-40px h-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>1</span>
                  </div>

                  <div className='stepper-label'>
                    <h3 className='stepper-title'>
                      {intl.formatMessage({id: 'LICENSES.TITLE_STEAP1'})}
                    </h3>
                    <div className='stepper-desc fw-bold'>
                      {intl.formatMessage({id: 'LICENSES.SUBTITLE2_STEAP1'})}
                    </div>
                  </div>
                </div>

                <div className='stepper-line h-40px'></div>
              </div>

              <div className='stepper-item' data-kt-stepper-element='nav'>
                <div className='stepper-wrapper'>
                  <div className='stepper-icon w-40px h-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>2</span>
                  </div>

                  <div className='stepper-label'>
                    <h3 className='stepper-title'>
                      {intl.formatMessage({id: 'LICENSES.TITLE_STEAP4'})}
                    </h3>
                    <div className='stepper-desc fw-bold'>
                      {intl.formatMessage({id: 'LICENSES.SUBTITLE2_STEAP4'})}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </AnimaBaixo>
      <div className='d-flex flex-row-fluid flex-center bg-body rounded'>
        <Formik validationSchema={currentSchema} initialValues={initValues} onSubmit={submitStep}>
          {() => (
            <Form className='py-15 p-20 w-100 w-xl-1200px' noValidate id='kt_create_account_form'>
              <div className='current' data-kt-stepper-element='content'>
                <Step1 />
              </div>

              <div data-kt-stepper-element='content'>
                <Step2 />
              </div>

              <div className='d-flex flex-stack pt-10'>
                <div className='mr-2'>
                  <button
                    onClick={prevStep}
                    type='button'
                    className='btn btn-lg btn-light-primary me-3'
                    data-kt-stepper-action='previous'
                  >
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr063.svg'
                      className='svg-icon-4 me-1'
                    />
                    {intl.formatMessage({id: 'COMMON.BACK_BUTTON'})}
                  </button>
                </div>

                <div>
                  <button type='submit' className='btn btn-lg btn-primary me-3' disabled={loading}>
                    {!loading && (
                      <span className='indicator-label'>
                        {passos !== totalpassos && intl.formatMessage({id: 'COMMON.NEXT'})}
                        {passos === totalpassos && intl.formatMessage({id: 'COMMON.SAVE_BUTTON'})}
                        {passos !== totalpassos && (
                          <KTSVG
                            path='/media/icons/duotune/arrows/arr064.svg'
                            className='svg-icon-3 ms-2 me-0'
                          />
                        )}
                      </span>
                    )}
                    {loading && (
                      <span className='indicator-progress' style={{display: 'block'}}>
                        {intl.formatMessage({id: 'COMMON.SAVING_BUTTON'})}{' '}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  )
}

export {Vertical}
